import { render, staticRenderFns } from "./mallDetail.vue?vue&type=template&id=24c017c5&scoped=true"
import script from "./mallDetail.vue?vue&type=script&lang=js"
export * from "./mallDetail.vue?vue&type=script&lang=js"
import style0 from "./mallDetail.vue?vue&type=style&index=0&id=24c017c5&prod&lang=less&scoped=true"
import style1 from "./mallDetail.vue?vue&type=style&index=1&id=24c017c5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c017c5",
  null
  
)

export default component.exports